module.exports = __webpack_public_path__ + "Roboto-Thin.90d3804f0231704c15cc.woff";


//////////////////
// WEBPACK FOOTER
// /app/~/roboto-fontface/fonts/Roboto/Roboto-Thin.woff
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-Thin.woff
// module chunks = 16